'use client'

import React, { ComponentType } from 'react'
import Link from 'components/router/Link'
import {
  tournamentSchedulePath,
  organizationPath,
  leaguesPath
} from 'shared/urlHelpers'
import ListItem from 'components/ListItem'
import { TournamentGroupsData } from 'data/tournaments'
import NewPagination from 'components/NewPagination'
import ContentHeader from 'components/layout/ContentHeader'
import { NewFilterArea } from 'components/filter/NewFilterArea'

interface Props {
  groups: TournamentGroupsData
}

const GroupsList: ComponentType<Props> = ({ groups }: Props) => {
  return (
    <>
      <NewFilterArea
        basePath={leaguesPath()}
        facets={groups.meta?.facets}
        totalCount={groups.meta?.totalCount}
        totalCountType="leagues"
      />
      <div className="view-vertical">
        {groups.data.map((g) => (
          <div key={g.id} className="my-4">
            <Link href={g.organization ? organizationPath(g.organization) : ''}>
              <span
                data-tooltip-content={g.organization ? 'Zur Ligenseite' : ''}
                data-tooltip-id="layout-tooltip"
              >
                <ContentHeader
                  title={g.name}
                  logo={
                    g.id === 'YouthNationalLeague' || g.id === 'MaleNationalLeague'
                      ? `img/logos/${g.id}.png`
                      : g.id !== 'AmateurLeague'
                      ? `img/logos/${g.id}.svg`
                      : 'img/handball-net-logo-sm.svg'
                  }
                />
              </span>
            </Link>
            {/* logo hardcoded in frontend by group id, group id is fixed (MaleNationalLeague,FemaleNationalLeague, ThirdNationalLeague, AmateurLeague) */}
            <div className="md:grid md:grid-cols-2 gap-2">
              {g.tournaments.map((t) => (
                <ListItem
                  key={t.id}
                  title={t.name}
                  text={t.organization?.name}
                  url={tournamentSchedulePath(t)}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
      <NewPagination
        pathname={leaguesPath()}
        searchParams={{}}
        pagination={groups.meta}
      />
    </>
  )
}

export default GroupsList
